import http from 'src/infrastructure/http'
import { parseFailedResponse, parseGoodResponse } from 'src/infrastructure/parse-axios-response'
import {
  BatchAndStockBatchDue, BatchesMovement, BatchInfo, CheckStockAtAddressParams, GenericApiErrors,
  GetAddressApiParams, GetBatchInfoApiParams, GetPkItemsApiParams, MoveBatchApiParams, Movimentation,
  PkItem, PkItemMovementApiParams, PkItemDidNotFitsApiParams, PostMovimentationApiParams, ValidatedAddress,
  ValidateMovementAddressApiParams, ValidatePkModelBarcodeApiParams,
} from './StockMovementsTypes'

export const validateSupervisorBadge = async (badge: string) => {
  try {
    const resultSuccess = await http.post('/v2/recebimento/supervisao/validar', null, {
      headers: { 'user-barcode': badge },
    })
    return parseGoodResponse(resultSuccess)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const getBatch = async (adress: string, batchOrProductCode: string, badge: string) => {
  try {
    const resultSuccess = await http.get(`v2/batch/address/${adress}`, {
      params: {
        id_batch_or_product_code: batchOrProductCode,
      },
      headers: { 'user-barcode': badge },
    })
    return parseGoodResponse<BatchAndStockBatchDue[]>(resultSuccess.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const moveBatch = async ({
  addressId, lotStockId, qty, userBadge,
}: MoveBatchApiParams) => {
  try {
    const result = await http.post('/estoque/abastecimento', {
      address_id: addressId,
      quantity: qty,
      lot_stock_id: lotStockId,
    }, {
      headers: {
        'user-barcode': userBadge,
      },
    })
    return parseGoodResponse(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const getAddress = async ({ address, fcId }: GetAddressApiParams) => {
  try {
    const [warehouse, street, shelf, bin] = address.split('-')
    const result = await http.post('/estoque/localizacao/validar', {
      galpao: warehouse,
      rua: street,
      posicao: shelf,
      escaninho: bin,
      fulfillment_center_id: fcId,
    })

    return parseGoodResponse<ValidatedAddress>(result.data['endere\u00e7o validado'])
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const getBatchInfo = async ({ batchId, fcId, badge }: GetBatchInfoApiParams) => {
  try {
    const result = await http.get(`v2/batch/${batchId}?fulfillment_center_id=${fcId}`, {
      headers: {
        'user-barcode': badge,
      },
    })

    return parseGoodResponse<BatchInfo>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const postMovimentation = async ({ idAddress, movimentations, badge }: PostMovimentationApiParams) => {
  const movimentationsParam = movimentations.map((movimentation: Movimentation) => ({
    id_stock_batch_due: movimentation.idStockBatchDue,
    quantity: movimentation.quantity,
  }))

  try {
    const result = await http.post('v2/batch/movimentation', { id_address: idAddress, movimentations: movimentationsParam },
      {
        headers: {
          'user-barcode': badge,
        },
      })

    return parseGoodResponse<BatchesMovement>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const getPkItems = async ({ fcId, address, badge }: GetPkItemsApiParams) => {
  try {
    const [shed, street, shelf, bin] = address.split('-')
    const result = await http.get('/v2/warehouse/location/products', {
      params: {
        fulfillment_center_id: fcId,
        shed,
        street,
        shelf,
        bin,
      },
      headers: {
        'user-barcode': badge,
      },
    })

    return parseGoodResponse<PkItem[]>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const validatePkModelBarcode = async ({ barcode, item }: ValidatePkModelBarcodeApiParams) => {
  try {
    const result = await http.post('/v2/warehouse/products/validate', {
      id_model: item.idModel,
      barcode,
    })

    return parseGoodResponse(result)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const validateMovementAddress = async ({
  idModel, address, addressToValidate, isGondola,
}: ValidateMovementAddressApiParams) => {
  try {
    const result = await http.post('/v2/warehouse/location/validate-address', {
      id_model: idModel,
      address,
      address_to_validate: addressToValidate,
      is_gondola: isGondola,
    })

    return parseGoodResponse(result)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const pkItemMovement = async ({ item, startedAt, badge }: PkItemMovementApiParams) => {
  try {
    const result = await http.post('v2/batch/movimentation', {
      id_address: item.bestPosition.id,
      movimentations: item.batches.map((batch) => ({
        id_stock_batch_due: batch.idBatchStockExpiration,
        quantity: batch.quantity,
      })),
      send_metric: {
        metric_code: 'MOVEMENT_PK',
        started_at: startedAt.toISOString(),
      },
    }, {
      headers: {
        'user-barcode': badge,
      },
    })

    return parseGoodResponse<BatchesMovement>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const checkStockAtAddress = async ({ address }: CheckStockAtAddressParams) => {
  try {
    const result = await http.get(`/v2/warehouse/location/check-stock/${address}`)
    return parseGoodResponse(result)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export const pkItemDidNotFits = async ({
  items, item, startedAt, badge,
}: PkItemDidNotFitsApiParams) => {
  try {
    const result = await http.post('/v2/warehouse/products/unfit-group', {
      movement_groups: items.map((_item) => ({
        id_model: _item.idModel,
        product_description: _item.productDescription,
        batches: _item.batches.map((batch) => ({
          id_batch_receivement: batch.idBatchReceivement,
          id_batch_stock_expiration: batch.idBatchStockExpiration,
          batch_number: batch.batchNumber,
          expiration_date: batch.expirationDate,
          quantity: batch.quantity,
        })),
        order: _item.order,
        volume: _item.volume,
        product_volume: _item.productVolume,
        is_pallet: _item.isPallet,
        is_gondola: _item.isGondola,
        best_position: {
          id: _item.bestPosition.id,
          address: _item.bestPosition.address,
        },
        gondola_address: {
          id: _item.gondolaAddress.id,
          address: _item.gondolaAddress.address,
        },
        done: _item.done || false,
        is_internal: _item.isInternal,
      })),
      unfit_group: {
        id_model: item.idModel,
        product_description: item.productDescription,
        batches: item.batches.map((batch) => ({
          id_batch_receivement: batch.idBatchReceivement,
          id_batch_stock_expiration: batch.idBatchStockExpiration,
          batch_number: batch.batchNumber,
          expiration_date: batch.expirationDate,
          quantity: batch.quantity,
        })),
        order: item.order,
        volume: item.volume,
        product_volume: item.productVolume,
        is_pallet: item.isPallet,
        is_gondola: item.isGondola,
        best_position: {
          id: item.bestPosition.id,
          address: item.bestPosition.address,
        },
        gondola_address: {
          id: item.gondolaAddress.id,
          address: item.gondolaAddress.address,
        },
        done: item.done || false,
        is_internal: item.isInternal,
      },
      quantity: item.batches.reduce((sum, batch) => sum + batch.quantity, 0),
      send_metric: {
        metric_code: 'MOVEMENT_PK',
        started_at: startedAt.toISOString(),
      },
    }, {
      headers: {
        'user-barcode': badge,
      },
    })

    return parseGoodResponse<PkItem[]>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}
